import { useAssetTransforms, useVideoDialog } from "@/Composables";

export default function useResources() {
    const { marketingAssetUrl, youTubeEmbed } = useAssetTransforms();
    const { toggleVideoDialog } = useVideoDialog();

    const getResource = (event, res) => {
        switch (res.asset.source) {
            case 3:
                window.open(marketingAssetUrl(res.asset.external_id), "_blank");
                break;
            case 4:
                toggleVideoDialog(
                    event,
                    youTubeEmbed(res.asset.external_id, true)
                );
                break;
        }
    };

    const transformElasticSearchResource = (resource) => {
        console.log('resource.facet_vendors[0].name', resource.facet_vendors[0] )
        return {
            id: resource.resource_id,
            name: resource.asset_name,
            asset: {
                source: parseInt(resource.asset_source),
                external_id: resource.asset_external_id,
            },
            vendors: [
                {
                    //TODO: Temporary fix
                    name: resource.facet_vendors[0]?.name ?? resource.facet_vendors[0],
                },
            ],
        };
    };

    return {
        getResource,
        transformElasticSearchResource,
    };
}
